/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Plugins_TabInputs */



/**
* | output |
* | --- |
* | "Plugins" |
*
* @param {Team_Manager_Plugins_TabInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_plugins_tab = /** @type {((inputs?: Team_Manager_Plugins_TabInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Plugins_TabInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Plug-ins")
	if (locale === "de") return /** @type {LocalizedString} */ ("Plugins")
	if (locale === "it") return /** @type {LocalizedString} */ ("Plugin")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Плагины")
	if (locale === "es") return /** @type {LocalizedString} */ ("Complementos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("插件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プラグイン")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्लग-इन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Plugins")
	return /** @type {LocalizedString} */ ("Plugins")
});